import { scheduleLiveStreamsSection } from '../shared/live-streams-section.js';

export function scheduleHomeLiveStreams() {
  scheduleLiveStreamsSection({
    mountId: 'home-live-streams-mount',
    slotId: 'home-live-streams-player-slot',
    wrapId: 'home-live-streams-player',
    qualityStorageKey: 'home-live-quality',
    swiperLayout: 'always',
    hideSectionWhenEmpty: true,
    sectionSelector: '#home-live-streams-section',
    autoPlayRandom: false,
    onClose: () => {
      document.querySelectorAll('#home-live-streams-mount .product-live-streams__card').forEach((item) => {
        item.classList.remove('is-active');
      });
    },
  });
}
